import { Typography } from '@mui/material';
import * as React from 'react';

interface ErrorPageProps {
  statusCode: number;
  message: string;
}

const Error404 = (props: ErrorPageProps) => {
  return (
    <Typography>
      Error {props.statusCode}: {props.message}
    </Typography>
  );
};

const ErrorPage = (props: ErrorPageProps) => {
  if (props.statusCode === 404) {
    return <Error404 {...props} />;
  }
  return <Typography>Whoops Something Went Wrong!</Typography>;
};

export default ErrorPage;
